import * as React from 'react';

import Minus16 from './Minus16';

export const minus16 = () => <Minus16 />;

export default {
    title: 'Icon/Fill/Minus16',
    component: Minus16,
    parameters: {
        notes: "`import Minus16 from 'box-ui-elements/es/icon/fill/Minus16';`",
    },
};
